import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24341 15603"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str1,.str2{stroke:#2b2a29;stroke-width:857.074}.str1{stroke-width:685.659}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974604511648">
        <path
          d="M2392 514h19557c1032 0 1878 846 1878 1878v5605c0 1033-846 1878-1878 1878H2392c-1033 0-1878-845-1878-1878V2392c0-1032 845-1878 1878-1878z"
          className="fill-none stroke1"
          style={{
            // stroke: "#2b2a29",
            strokeWidth: 1028.49,
          }}
        />
        <path
          d="M19001 2727h2087v2087h-2087zM2743 7721h18855v-792H2743z"
          className="fill"
          style={{
            strokeWidth: 1028.49,
          }}
        />
        <path
          d="M11708 11091c396 449 793 898 785 1256-7 359-418 625-624 990-205 366-205 829-43 1159 161 331 484 527 645 625l162 99M17968 11091c396 449 793 898 785 1256-7 359-418 625-623 990-206 366-206 829-45 1159 162 331 485 527 647 625l161 99M5448 11091c396 449 793 898 786 1256-8 359-419 625-625 990-205 366-205 829-44 1159 162 331 485 527 646 625l162 99"
          className="stroke1"
          style={{
            strokeWidth: 857.074,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
